export default __webpack_public_path__ + "static/media/1-min.3d9db2c5.jpg";